var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF06A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-home---single-page",
    transform: "translate(-820.000000, -1027.000000)",
    fill: "#0C1F28",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(429.000000, 803.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,244 C406.520833,244 411,239.520833 411,234 C411,228.479167 406.520833,224 401,224 C395.479167,224 391,228.479167 391,234 C391,239.520833 395.479167,244 401,244 Z M402.197917,236.083333 L399.789062,236.083333 C399.541667,236.083333 399.346354,235.940104 399.346354,235.757812 L399.125,227.671875 C399.125,227.580729 399.164062,227.489583 399.255208,227.4375 C399.333333,227.372396 399.450521,227.333333 399.567708,227.333333 L402.432292,227.333333 C402.549479,227.333333 402.666667,227.372396 402.744792,227.4375 C402.835938,227.489583 402.875,227.580729 402.875,227.671875 L402.640625,235.757812 C402.627604,235.940104 402.432292,236.083333 402.197917,236.083333 Z M402.263021,240.666667 L399.763021,240.666667 C399.528646,240.666667 399.333333,240.471354 399.333333,240.236979 L399.333333,237.763021 C399.333333,237.528646 399.528646,237.333333 399.763021,237.333333 L402.263021,237.333333 C402.484375,237.333333 402.666667,237.528646 402.666667,237.763021 L402.666667,240.236979 C402.666667,240.471354 402.484375,240.666667 402.263021,240.666667 Z",
    id: "\\uF06A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/not-available.76c02c50fe0d5536157b542a81ba2589.svg";
export { ForwardRef as ReactComponent };